import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import styles from './object-detail.scss';
import ObjectDetailDefinition from './Definition';
import Location from './Location';
import ObjectTitle from '../ObjectTitle';
import ObjectSlider from '../Slider';
import Markdown from '../../shared/Markdown';
import StandardImage from '../../shared/StandardImage';
import ObjectRelObjects from '../RelObjects';
import ObjectRelDesigners from '../RelPersons/Designers';
import ObjectRelProducers from '../RelPersons/Producers';
import DetailHeader from '../../shared/DetailHeader';
import Toolbar from '../../shared/Toolbar';
import SocialShare from '../../shared/SocialShare';
import TextSlider from '../../shared/TextSlider';
import IconBar from '../IconBar';
import settings from '../../../../config/settings';
import localize from '../../../localize';
import { objectTitle } from '../../../common';
import {
    getCurrentLanguage,
    addToMyCollection,
    showTextForKids,
    isNavigationActive,
} from '../../../localData';

class ObjectDetail extends Component {

    static propTypes = {
        store: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        routeParams: PropTypes.object.isRequired,
    };

    componentWillMount() {
        this.setState({
            showSocialShare: false
        });
    }

    handleAddToMyCollection = () => {
        const id = this.props.store.object.id;
        addToMyCollection('objects', id);
    };

    toggleSocialSharing = () => {
        this.setState({
            showSocialShare: !this.state.showSocialShare
        });
    };

    l = (key) => {
        const str = `${getCurrentLanguage()}.components.ObjectDetail.${key}`;
        return localize(str);
    };

    getShareTitle = (obj) => {
        const titleParts = [];

        if (!!obj.ObjDesigner) {
            titleParts.push(obj.ObjDesigner);
        }
        titleParts.push(objectTitle(obj));

        return titleParts.join(', ');
    };

    getShareUrl = () => {
        const path = this.props.route.path
            .replace(':lang', this.props.routeParams.lang)
            .replace(':id', this.props.routeParams.id);

        return `${settings.socialSharing.baseUrl}/#${path}`;
    };

    getText = (obj) => {
        if (showTextForKids() && !!obj.ObjMarkdownKids) {
            return obj.ObjMarkdownKids;
        } else {
            return obj.ObjMarkdown;
        }
    };

    render() {
        const { store, relay, history } = this.props;
        const obj = this.props.store.object;
        let headerClass = "detail-header detail-section-content";
        headerClass += !!obj.ObjStandardImage ? '' : ' no-standard-image';
        const text = this.getText(obj);

        return (
            <div className="object">
                <DetailHeader
                    relay={ relay }
                    isNavigationActive={isNavigationActive()}
                    hasStandardImage={!!obj.ObjStandardImage}
                    detail={{
                        imageUrl: obj.ObjThumbnail,
                        title: <ObjectTitle object={ obj } />,
                        txt: obj.ObjDesigner
                    }}
                />
                <StandardImage imageUrl={ obj.ObjStandardImage } isNavigationActive={isNavigationActive()} />
                <header
                    id="detailHeader"
                    className={ headerClass }
                    styleName={!!settings.Object.list.showIconBar ? 'has-icon-bar' : '' }
                >
                    {
                        !!settings.Object.list.showIconBar &&
                        <div className="content-box">
                            <IconBar object={ obj } />
                        </div>
                    }
                    <div className="content-box">
                        <TextSlider>
                            <h1>
                                <ObjectTitle object={ obj } />
                            </h1>
                        </TextSlider>
                        <p className="h1 artist">
                            { obj.ObjDesigner }
                        </p>
                    </div>
                </header>
                {
                    !this.state.showSocialShare &&
                    <div className="detail-body">
                        <Toolbar
                            handleAddToMyCollection={ this.handleAddToMyCollection }
                            handleSharing={ this.toggleSocialSharing }
                        />
                        <ObjectDetailDefinition
                            object={ obj }
                            lang={ getCurrentLanguage() }
                            styles={ styles } relay={ relay }
                        />
                        {
                            !!settings.Object.detail.showObjFloorplan &&
                            <Location object={obj} relay={relay} styles={styles} />
                        }
                        {
                            !!text &&
                            <div styleName="section-content">
                                <Markdown source={ text } />
                            </div>
                        }
                        {
                            obj.ObjMultimediaCount > 0 &&
                            <div styleName="slider-container">
                                <ObjectSlider
                                    store={ store }
                                    object={ obj }
                                    history={ history }
                                    multimediaWidths={JSON.parse(this.props.store.object.ObjMultimediaWidths)}
                                    multimediaCount={obj.ObjMultimediaCount}
                                    isNavigationActive={isNavigationActive()}
                                />
                            </div>
                        }
                        <ObjectRelObjects object={ obj } title={ this.l('ObjObjectRel') } />
                        <ObjectRelDesigners object={ obj } title={ this.l('ObjRelDesigners') } />
                        <ObjectRelProducers object={ obj } title={ this.l('ObjRelProducers') } />
                    </div>
                }
                {
                    this.state.showSocialShare &&
                    <SocialShare
                        lang={ getCurrentLanguage() }
                        title={ this.getShareTitle(obj) }
                        url={ this.getShareUrl() }
                        onClose={ this.toggleSocialSharing }
                    />
                }
            </div>
        );
    }
};

export default CSSModules(ObjectDetail, styles);


// WEBPACK FOOTER //
// ./app/components/Object/Detail/ObjectDetail.jsx